export default __webpack_public_path__ + "media/color/blk-e4592401.svg";